import { MEDIA_UPLOAD_LIMIT_BYTES } from '@ghp/domain'
import type { ApiClient } from '@ghp/api-client'

const VIDEO_LIMIT_KEY = 'ghp-terrain-video-limit-bytes'

/**
 * La limite d'une vidéo que la tablette **retient** de la dernière synchro (#418) : 1 Go quand
 * le serveur la prend en direct, 25 Mo par le relais (mode disque).
 *
 * Retenue parce que l'agent choisit ses fichiers hors réseau. 25 Mo tant que le serveur ne l'a
 * pas dite : accepter une vidéo de 400 Mo qu'un serveur en relais refuserait rendrait le relevé
 * entier intransmissible.
 */
export function rememberedVideoLimit(): number {
  try {
    const stored = Number(localStorage.getItem(VIDEO_LIMIT_KEY))

    return stored > 0 ? stored : MEDIA_UPLOAD_LIMIT_BYTES
  } catch {
    // localStorage refusé (navigation privée verrouillée) : la limite sûre.
    return MEDIA_UPLOAD_LIMIT_BYTES
  }
}

/**
 * Relit la limite auprès du serveur et la retient. Un échec garde la dernière connue : c'est une
 * lecture de confort, la synchro n'a rien à rattraper.
 */
export async function pullMediaPolicy(
  api: Pick<ApiClient['sync'], 'mediaPolicy'>,
  accessToken: string | null,
): Promise<void> {
  if (!accessToken) return

  try {
    const { videoLimitBytes } = await api.mediaPolicy(accessToken)
    localStorage.setItem(VIDEO_LIMIT_KEY, String(videoLimitBytes))
  } catch {
    // Hors réseau, refusé, ou localStorage plein : la dernière limite connue vaut.
  }
}
